import { render, staticRenderFns } from "./BanMember.vue?vue&type=template&id=232e2902&scoped=true&"
import script from "./BanMember.vue?vue&type=script&lang=js&"
export * from "./BanMember.vue?vue&type=script&lang=js&"
import style0 from "./BanMember.vue?vue&type=style&index=0&id=232e2902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e2902",
  null
  
)

export default component.exports